import { Placeholder } from '@topconagriculture/react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import { WidgetType } from '../../widget.types';
const useStyles = makeStyles(() => ({
    placeholder: {
        '& .icon-ingredients': { fontSize: '60px!important' },
        '& .icon-feed-group': { fontSize: '80px!important' },
        '& span': { margin: 0, lineHeight: 1, fontSize: 14, maxWidth: 'none!important' },
    },
    wrapper: {
        height: 560,
    },
}));
const dataMap = {
    [WidgetType.LOAD_DEVIATION]: {
        title: 'widget:load_deviation:no_ingredient_alerts',
        description: 'widget:load_deviation:no_ingredient_alerts_description',
        iconName: 'ingredients',
    },
    [WidgetType.DELIVER_DEVIATION]: {
        title: 'widget:deliver_deviation:no_pen_alerts',
        description: 'widget:deliver_deviation:no_pen_alerts_description',
        iconName: 'feed-group',
    },
};
export const NoAlerts = ({ widgetType }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    return (React.createElement("div", { className: classes.wrapper },
        React.createElement(Placeholder, { title: t(dataMap[widgetType].title), description: t(dataMap[widgetType].description), iconName: dataMap[widgetType].iconName, className: classes.placeholder })));
};
//# sourceMappingURL=NoAlerts.js.map